import { ChangeDetectionStrategy, Component, ElementRef, output, viewChild, HostListener } from '@angular/core';
import { BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { Projet } from 'src/app/bo/projet';
import { HttpService } from 'src/app/services/http.service';
import { Tir } from '../../bo/tir';
import { TypeTir } from '../../bo/TypeTir';
import { Zone } from '../../bo/zone';
import { FonctionsService } from '../../services/fonctions-partagees.service';
import { UtilisateurService } from '../../services/utilisateur.service';
import posthog from 'posthog-js';
import { CookieService } from 'ngx-cookie-service';
import { KpiService } from 'src/app/services/kpi.service';
import { ConfigurationSaisieDonneesAnalyse } from 'src/app/bo/configurationSaisieDonneesAnalyse';
import { KeyValue, MultiKpi } from 'src/app/bo/donneeAnalyse';
import { Site } from 'src/app/bo/site';
import { OperationType } from 'src/app/bo/operationTypeEnum';


@Component({
  selector: 'app-tir-modale',
  templateUrl: './tir-modale.component.html',
  styleUrls: ['./tir-modale.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TirModaleComponent {
  readonly modalConfirmCancel = viewChild<ModalDirective>('modalConfirmCancel');
  readonly modalConfirmSuppr = viewChild<ModalDirective>('modalConfirmSuppr');
  readonly modifTir = output<Tir>();
  readonly fileInput = viewChild<ElementRef>('fileInput');
  tir: Tir;
  site: Site;
  tabZones: Zone[];
  tabTypeTirs: TypeTir[];
  tabProjets: Projet[] = [];
  operationalCategories: { id: string; nom: string }[] = [
    { id: "blast_ug", nom: "Blast UG" },
    { id: "blast_op", nom: "Blast OP" }
  ];
  selectedOperationalCategory: { id: string; nom: string };
  isOperationalCategoryDisabled = false;
  zoneSelectionnee: Zone;
  projetId: number;
  datePrevDebutProjet: Date;
  datePrevFinProjet: Date;
  dateEffDebProjet: Date;
  dateEffFinProjet: Date;
  success: boolean;
  suppression = false;
  nomInvalide = false;
  zoneInvalide = false;
  datePrevInvalide = false;
  estModif: boolean;
  nomTir: string;
  annul = false;
  currentDate: Date;
  tirSauv: Tir;
  erreurApi: boolean;
  HeureEff = 12;

  get isFrench(): boolean {
    return (this.cookieService.get('epcLanguage') || 'en') === 'fr';
  }
  typeTirSelectionne: TypeTir;
  niveauTir: string;
  typeTirInvalide: boolean;
  nameAlreadyExists: boolean;
  isForbidenCharacters: boolean;
  isBlasted = false;
  hasBlastedChanged = false;
  isDeleted = false;
  isDragOver = false;
  viewTab: "GENERAL" | "KPI" = "GENERAL";
  configAnalysis: (ConfigurationSaisieDonneesAnalyse & { 
    valeurSaisie?: string; 
    valeurBooleen?: boolean; 
  })[] = [];
  kpiRows: any[][] = [];
  multiKpi: MultiKpi = new MultiKpi();
  
  
  constructor(
    private readonly http: HttpService,
    private readonly bsModalRef: BsModalRef,
    private readonly fonctionsService: FonctionsService,
    private readonly utilService: UtilisateurService,
    private readonly kpiService: KpiService,
    private readonly cookieService: CookieService) {

    this.dateEffDebProjet = utilService.currentProjet.dateDebutEffective ? new Date(utilService.currentProjet.dateDebutEffective) : new Date(2000, 1, 1);
    if (utilService.currentProjet.dateFinEffective)
      this.dateEffFinProjet = new Date(utilService.currentProjet.dateFinEffective);
    else {
      this.dateEffFinProjet = new Date();
      this.dateEffFinProjet.setFullYear(this.dateEffFinProjet.getFullYear() + 1);
    }
  }

  ngOnInit() {
    this.site = this.utilService.currentSite();
    this.setDefaultOperationalCategory();
    this.kpiService.getSiteConfigAnalysisEntry(this.utilService.currentSite().siteId).subscribe(donnees => {
      this.configAnalysis = donnees.filter(da => da.isEnabled === true);
      this.configAnalysis.forEach(kpi => {
        if (kpi.referentielDonneeAnalyse.typeSaisieKpi === 'InputText') {
          (kpi as any).valeurSaisie = kpi.valeurNominal?.toString() || '';
        } else if (kpi.referentielDonneeAnalyse.typeSaisieKpi === 'YesOrNo') {
          (kpi as any).valeurBooleen = false;
        }
        
        const keyValue = new KeyValue();
        keyValue.key = kpi.referentielDonneeAnalyse.referentielDonneeAnalyseId;
        keyValue.value = '';
        this.multiKpi.keyValues.push(keyValue);
      });
      this.createKpiRows();
    });

    console.log(this.estModif)

    this.currentDate = new Date();
    this.isBlasted = this.tir?.blasted === 1; 
    if (!this.estModif) {

      this.datePrevDebutProjet = new Date(this.utilService.currentProjet.dateDebutPrevisionnelle);
      this.datePrevFinProjet = new Date(this.utilService.currentProjet.dateFinPrevisionnelle);

      this.tir = new Tir();
      this.tir.nom = this.nomTir;
      this.tir.projetId = this.projetId;
      this.tir.niveau = this.niveauTir;
      if (this.currentDate > this.datePrevFinProjet) {
        this.tir.dateTirPrevisionnelle = this.datePrevFinProjet;
      } else {
        this.tir.dateTirPrevisionnelle = this.currentDate;
      }
      if (this.tabZones.length == 1)
        this.zoneSelectionnee = this.tabZones[0];
      if (this.tabTypeTirs.length == 1)
        this.typeTirSelectionne = this.tabTypeTirs[0];
    } else {
      if (this.tir.dateTirEffective) {
        this.HeureEff = this.tir.dateTirEffective.getHours();
        this.tir.dateTirEffective.setHours(this.HeureEff);
      }
      // this.tir.dateTirPrevisionnelle = this.fonctionsService.normalisationDateTime(this.tir.dateTirPrevisionnelle, 0);

      console.log(  this.tir.dateTirPrevisionnelle)
      this.tirSauv = Object.assign('', this.tir);
    }
  }

  @HostListener('window:keydown.esc', ['$event'])
  onEsc(event: any): void {
    if (event.keyCode === 27) {
      event.preventDefault();
    }
    this.showModalCancel();
  }



  onSubmit() {
    posthog.capture('TirModaleComponent.onSubmit');
    this.erreurApi = false;
    
    // Si isDeleted est true, afficher la modale de confirmation de suppression
    if (this.isDeleted) {
      this.modalConfirmSuppr()?.show();
      return;
    }
    
    if (this.validationFormulaire()) {
      this.fonctionsService.loading_screen(true);
      this.tir.nom = this.tir.nom.trim();
      this.tir.zoneId = this.zoneSelectionnee.zoneId;

      if (this.typeTirSelectionne.typeTirId) {
        this.tir.typeTir = this.typeTirSelectionne;
        this.tir.typeTirId = this.typeTirSelectionne.typeTirId;
      }
      else {
        this.tir.typeTir = new TypeTir();
        this.tir.typeTirId = -1;
        this.tir.typeTir.nom = this.typeTirSelectionne.nom;
        this.tir.typeTir.siteId = this.utilService.currentSite().siteId;
      }
      if (null !== this.tir.dateTirEffective && undefined !== this.tir.dateTirEffective) {
        this.tir.dateTirEffective.setHours(this.HeureEff);
        this.tir.dateTirEffective.setMinutes(0);
        this.tir.dateTirEffective.setSeconds(0);
      }
      else if(this.isBlasted){
        this.tir.dateTirEffective = new Date();
      }
      
      this.tir.niveau = this.niveauTir;
      this.tir.siteId = this.utilService.currentSite().siteId;
      this.tir.blasted = this.isBlasted ? 1 : 0;
      
      var requete = this.estModif ? this.http.put<Tir, Tir>('Blasts', this.tir) : this.http.post<Tir, Tir>('Blasts', this.tir);
      requete.subscribe(resultat => {
        if (resultat) {
          this.success = true;

          if (this.selectedOperationalCategory?.id === 'blast_ug' && !this.estModif) {
            this.multiKpi.tirId = resultat.tirId;
            this.synchroniserDonneesAnalyse();
            
            this.kpiService.AddDonneeAnalyse(this.multiKpi).subscribe(
              kpiResult => {
                console.log('KPIs sauvegardés avec succès', kpiResult);
              },
              kpiError => {
                console.error('Erreur lors de la sauvegarde des KPIs', kpiError);
              }
            );
          }
          
          this.modifTir.emit(resultat);
        }
        else{
          this.erreurApi = true;
        }
        this.fonctionsService.loading_screen(false);
        if (!this.erreurApi) {
          this.fonctionsService.launch_toast(this.success);
          this.bsModalRef.hide();
        }
      }, () => {
        this.erreurApi = true;
        this.fonctionsService.loading_screen(false);
      });
    }
  }


  onFocusOutEvent(nomTir: string) {
    this.nameAlreadyExists = false;

    const format = /[*\\[\];:\\|,."\/]/;
    this.isForbidenCharacters = format.test(nomTir);

    if (this.isForbidenCharacters) return;

    // Si c'est une modification et le nom n'a pas changé, pas besoin de vérifier
    if (this.estModif && this.tirSauv && nomTir === this.tirSauv.nom) {
      return;
    }

    let encodednomTir = btoa(nomTir);
    const projectId = this.tir.projetId;

    this.http.get<boolean>(
      'Sites/' + this.utilService.currentSite().siteId + '/GetTirByName/' + encodednomTir + (projectId ? ('?projectId=' + projectId) : '')
    ).subscribe((result) => {
      this.nameAlreadyExists = result;
    });
  }


  validationFormulaire() {
    this.nomInvalide = this.fonctionsService.stringEstVide(this.tir.nom);
    this.zoneInvalide = !this.zoneSelectionnee;
    this.typeTirInvalide = !this.typeTirSelectionne;
    this.datePrevInvalide = !this.tir.dateTirPrevisionnelle;

    return !this.nomInvalide && !this.zoneInvalide && !this.datePrevInvalide && !this.typeTirInvalide && !this.nameAlreadyExists && !this.isForbidenCharacters;
  }


  delete() {
    this.fonctionsService.loading_screen(true);
    this.suppression = true;
    this.http.delete('Blasts/' + this.tir.tirId).subscribe(resultat => {
      if (resultat) {
        this.success = true;
        this.modifTir.emit(null);
      } else {
        this.erreurApi = true;
      }
      this.fonctionsService.loading_screen(false);
      if (!this.erreurApi) {
        this.fonctionsService.launch_toast(this.success, true);
        this.modalConfirmSuppr()?.hide();
        this.bsModalRef.hide();
      }
    }, () => {
      this.erreurApi = true;
      this.fonctionsService.loading_screen(false);
    });
  }

  nettoyerDates(field: 'dateTirPrevisionnelle' | 'dateTirEffective') {
    this.tir[field] = null;
  }

  showModalCancel() {
    if (this.diff()) {
      this.modalConfirmCancel()?.show();
    } else {
      this.annulModif();
    }
  }

  diff() {
    if (this.estModif) {
      let datePrevModif = false;
      let dateEffModif = false;

      if ((!this.tir.dateTirPrevisionnelle && this.tirSauv.dateTirPrevisionnelle) ||
        (this.tir.dateTirPrevisionnelle && !this.tirSauv.dateTirPrevisionnelle) ||
        this.tir.dateTirPrevisionnelle &&
        (this.tir.dateTirPrevisionnelle.getDay() !== this.tirSauv.dateTirPrevisionnelle.getDay() ||
          this.tir.dateTirPrevisionnelle.getMonth() !== this.tirSauv.dateTirPrevisionnelle.getMonth() ||
          this.tir.dateTirPrevisionnelle.getFullYear() !== this.tirSauv.dateTirPrevisionnelle.getFullYear()))
        datePrevModif = true;

      if ((!this.tir.dateTirEffective && this.tirSauv.dateTirEffective) ||
        (this.tir.dateTirEffective && !this.tirSauv.dateTirEffective) ||
        this.tir.dateTirEffective &&
        (this.tir.dateTirPrevisionnelle.getDay() !== this.tirSauv.dateTirEffective.getDay() ||
          this.tir.dateTirPrevisionnelle.getMonth() !== this.tirSauv.dateTirEffective.getMonth() ||
          this.tir.dateTirPrevisionnelle.getFullYear() !== this.tirSauv.dateTirEffective.getFullYear()))
        dateEffModif = true;

      return this.tir.nom !== this.tirSauv.nom ||
        datePrevModif || dateEffModif ||
        this.zoneSelectionnee.zoneId !== this.tirSauv.zoneId;
    } else {
      let datePrevModif = false;
      if (!this.tir.dateTirPrevisionnelle ||
        this.tir.dateTirPrevisionnelle.getDay() !== this.currentDate.getDay() ||
        this.tir.dateTirPrevisionnelle.getMonth() !== this.currentDate.getMonth() ||
        this.tir.dateTirPrevisionnelle.getFullYear() !== this.currentDate.getFullYear())
        datePrevModif = true;

      return this.tir.nom !== this.nomTir ||
        datePrevModif ||
        this.zoneSelectionnee ||
        this.tir.dateTirEffective;
    }
  }

  annulModif() {
    this.annul = true;
    this.bsModalRef.hide();
  }

  changeBlasted(){
    this.isBlasted = !this.isBlasted;
    this.hasBlastedChanged = this.isBlasted;
  }

  protected onClose(): void {
   if (this.diff()) {
      this.modalConfirmCancel()?.show();
    } else {
      this.annulModif();
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
    
    const droppedFiles = event.dataTransfer?.files;
    if (droppedFiles && droppedFiles.length > 0) {
      // this.processFiles(droppedFiles);
    }
  }

  triggerFileInput(): void {
    const input = this.fileInput();
    if (input && input.nativeElement) {
      input.nativeElement.click();
    }
  }

  filesFromInput(e: any) {
    const fileList = e.srcElement.files;
    if (fileList && fileList.length > 0) {
      // this.processFiles(fileList);
    }
  }

  shouldShowDragDropZone(): boolean {
    return !this.selectedOperationalCategory || this.selectedOperationalCategory.id !== 'blast_op';
  }

  getKpiRows(): any[][] {
    if (!this.configAnalysis || this.configAnalysis.length === 0) {
      return [];
    }
    
    const rows = [];
    for (let i = 0; i < this.configAnalysis.length; i += 3) {
      rows.push(this.configAnalysis.slice(i, i + 3));
    }
    return rows;
  }

  createKpiRows(): void {
    this.kpiRows = [];
    if (this.configAnalysis && this.configAnalysis.length > 0) {
      const kpisByCategory = this.groupKpisByCategory();

      Object.keys(kpisByCategory).forEach(category => {
        const categoryKpis = kpisByCategory[category];

        this.kpiRows.push([{ isCategory: true, categoryName: category }]);
        for (let i = 0; i < categoryKpis.length; i += 3) {
          this.kpiRows.push(categoryKpis.slice(i, i + 3));
        }
      });
    }
  }

  synchroniserDonneesAnalyse(): void {
    if (this.tir && this.tir.tirId) {
      this.multiKpi.tirId = this.tir.tirId;
    }
    
    this.configAnalysis.forEach((kpi, index) => {
      if (index < this.multiKpi.keyValues.length) {
        const keyValue = this.multiKpi.keyValues[index];
        
        if (kpi.referentielDonneeAnalyse.typeSaisieKpi === 'InputText') {
          keyValue.value = (kpi as any).valeurSaisie || '';
        } else if (kpi.referentielDonneeAnalyse.typeSaisieKpi === 'YesOrNo') {
          keyValue.value = (kpi as any).valeurBooleen ? 'Oui' : 'Non';
        }
      }
    });
  }

  onKpiInputChange(kpi: any, value: string): void {
    const kpiIndex = this.configAnalysis.findIndex(config => 
      config.referentielDonneeAnalyse.referentielDonneeAnalyseId === kpi.referentielDonneeAnalyse.referentielDonneeAnalyseId
    );
    
    if (kpiIndex >= 0 && kpiIndex < this.multiKpi.keyValues.length) {
      kpi.valeurSaisie = value;
      this.multiKpi.keyValues[kpiIndex].value = value;
    }
  }

  onKpiBooleanChange(kpi: any, value: boolean): void {
    const kpiIndex = this.configAnalysis.findIndex(config => 
      config.referentielDonneeAnalyse.referentielDonneeAnalyseId === kpi.referentielDonneeAnalyse.referentielDonneeAnalyseId
    );
    
    if (kpiIndex >= 0 && kpiIndex < this.multiKpi.keyValues.length) {
      kpi.valeurBooleen = value;
      this.multiKpi.keyValues[kpiIndex].value = value ? 'Oui' : 'Non';
    }
  }
    private groupKpisByCategory(): { [key: string]: any[] } {
    const groups: { [key: string]: any[] } = {};

    this.configAnalysis.forEach(kpi => {
      const category = kpi.referentielDonneeAnalyse.type || 'Autres';

      if (!groups[category]) {
        groups[category] = [];
      }

      groups[category].push(kpi);
    });

    return groups;
  }
   onOperationalCategoryChange(): void {
    if (this.selectedOperationalCategory && this.selectedOperationalCategory.id === 'blast_op') {
      this.viewTab = 'GENERAL';
    }
  }

  shouldShowKpiTab(): boolean {
    return !this.selectedOperationalCategory || this.selectedOperationalCategory.id !== 'blast_op';
  }

  setDefaultOperationalCategory() {
    if (this.site && this.site.operationType) {
      this.isOperationalCategoryDisabled = true;
      if (this.site.operationType === OperationType.OP) {
        this.selectedOperationalCategory = this.operationalCategories.find(cat => cat.id === 'blast_op');
      } else if (this.site.operationType === OperationType.UG) {
        this.selectedOperationalCategory = this.operationalCategories.find(cat => cat.id === 'blast_ug');
      }
    } else {
      this.isOperationalCategoryDisabled = false;
    }
  }
}
